import {
  APPLICATION_TYPES,
  DEFAULT_USER_APP_TYPE_KEY,
  ENABLED_APP_TYPES,
  REDIRECT_NOT_ALLOWED_URL,
  REDIRECT_TO_LOGIN_URL,
  ROUTE_AGRONOMY_AGREEMENT_HOME,
  ROUTE_CROP_HOME,
  ROUTE_ENVIRONMENTAL_CROPS_HOME,
  ROUTE_SEED_HOME,
} from 'appConstants';

import { locationStartsWith } from './url';

const NEUTRAL_ROUTES = ['/', '/callback', REDIRECT_TO_LOGIN_URL, REDIRECT_NOT_ALLOWED_URL];

export const getInitialAppType = () => {
  const savedAppType = getAppTypeFromStorage();

  if (locationStartsWith(ROUTE_CROP_HOME) && ENABLED_APP_TYPES[APPLICATION_TYPES.CROP])
    return APPLICATION_TYPES.CROP;
  if (locationStartsWith(ROUTE_SEED_HOME) && ENABLED_APP_TYPES[APPLICATION_TYPES.SEED])
    return APPLICATION_TYPES.SEED;
  if (
    locationStartsWith(ROUTE_ENVIRONMENTAL_CROPS_HOME) &&
    ENABLED_APP_TYPES[APPLICATION_TYPES.ENVIRONMENTAL_CROPS]
  )
    return APPLICATION_TYPES.ENVIRONMENTAL_CROPS;
  if (
    locationStartsWith(ROUTE_AGRONOMY_AGREEMENT_HOME) &&
    ENABLED_APP_TYPES[APPLICATION_TYPES.AGRONOMY_AGREEMENT]
  )
    return APPLICATION_TYPES.AGRONOMY_AGREEMENT;

  if (NEUTRAL_ROUTES.includes(window.location.pathname)) return savedAppType || null;

  return savedAppType || APPLICATION_TYPES.FERTILISER;
};

export const getAppTypeFromStorage = () => {
  const localStorageAppType = localStorage.getItem(DEFAULT_USER_APP_TYPE_KEY);

  if (localStorageAppType) {
    if (ENABLED_APP_TYPES[localStorageAppType]) {
      return localStorageAppType;
    }

    localStorage.removeItem(DEFAULT_USER_APP_TYPE_KEY);
  }

  return null;
};
